// extracted by mini-css-extract-plugin
export default {"removePermissionButton":"removePermissionButton---m7OpB","removePermissionIcon":"removePermissionIcon---MDkSL"};